import { ReactNode } from 'react'

import styles from './Alert.module.scss'

export type AlertKind = 'success' | 'danger' | 'warning' | 'info'

export function Alert({
  kind,
  children,
  onDismiss,
  centered = false,
  className = '',
  ...rest
}: {
  kind: AlertKind
  children: ReactNode
  onDismiss?: () => void
  centered?: boolean
  className?: string
} & React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={`alert alert-theme alert-${kind}${onDismiss ? ' alert-dismissible' : ''}${
        centered ? ` ${styles.centered}` : ''
      } ${className}`.trim()}
      role="alert"
      data-testid="alert"
      data-kind={kind}
      {...rest}
    >
      {onDismiss && (
        <button type="button" className={`close ${styles.dismiss}`} aria-label="Close" onClick={onDismiss}>
          <span aria-hidden="true">×</span>
        </button>
      )}
      {children}
    </div>
  )
}
